"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var BHTP_CHECK_BOX_VALUE_ACCESSOR = {
    provide: forms_1.NG_VALUE_ACCESSOR,
    useExisting: core_1.forwardRef(function () { return BhtpCheckBoxComponent; }),
    multi: true
};
var BhtpCheckBoxComponent = (function () {
    function BhtpCheckBoxComponent(fb) {
        var _this = this;
        this.fb = fb;
        this.propagateChange = function (_) { };
        this.onTouched = function () { };
        this.checkBox = this.fb.control(null);
        // whenever the hidden control changes, propagate up
        this.checkBox.valueChanges.subscribe(function (checked) {
            _this.propagateChange(checked);
        });
    }
    BhtpCheckBoxComponent.prototype.writeValue = function (obj) {
        this.checkBox.setValue(obj);
    };
    BhtpCheckBoxComponent.prototype.registerOnChange = function (fn) {
        this.propagateChange = fn;
    };
    BhtpCheckBoxComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    BhtpCheckBoxComponent.prototype.setDisabledState = function (isDisabled) {
        if (isDisabled) {
            this.checkBox.disable();
        }
        else {
            this.checkBox.enable();
        }
    };
    BhtpCheckBoxComponent.prototype.sendPropagateChange = function (value) {
        this.propagateChange(value);
    };
    return BhtpCheckBoxComponent;
}());
BhtpCheckBoxComponent = __decorate([
    core_1.Component({
        selector: 'bhtp-check-box',
        template: "<label *ngIf=\"checkBox\">     <span *ngIf=\"checkBox.value\" class=\"fa fa-lg fa-check-square selected\" [ngClass]=\"{'disabled': checkBox.disabled}\"></span>     <span *ngIf=\"!checkBox.value\" class=\"fa fa-lg fa-square-o\" [ngClass]=\"{'disabled': checkBox.disabled}\"></span>     <input [formControl]=\"checkBox\" type=\"checkbox\" class=\"hidden-control\" /> </label>",
        styles: [".hidden-control {     display: none; }  .selected {     color: #364F78; }  .disabled, .selected.disabled {     color: #A6A6A6; }"],
        providers: [BHTP_CHECK_BOX_VALUE_ACCESSOR]
    }),
    __metadata("design:paramtypes", [forms_1.FormBuilder])
], BhtpCheckBoxComponent);
exports.BhtpCheckBoxComponent = BhtpCheckBoxComponent;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/form-controls/bhtp-check-box.component.js